var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6637_128116)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55003 4.45154C9.23089 3.48048 11.1844 3.08901 13.1096 3.33743C15.0349 3.58584 16.8251 4.46037 18.2044 5.82629C19.5837 7.19221 20.4757 8.97375 20.7429 10.8965C20.7999 11.3067 20.5135 11.6856 20.1032 11.7426C19.693 11.7996 19.3142 11.5132 19.2571 11.1029C19.0352 9.5061 18.2944 8.02652 17.1489 6.89212C16.0034 5.75771 14.5166 5.03141 12.9177 4.82509C11.3188 4.61878 9.69635 4.9439 8.30038 5.75037C7.24352 6.36093 6.36083 7.22174 5.72532 8.24971H8C8.41421 8.24971 8.75 8.58549 8.75 8.99971C8.75 9.41392 8.41421 9.74971 8 9.74971H4.51679C4.50542 9.74997 4.49402 9.74997 4.48261 9.74971H4C3.58579 9.74971 3.25 9.41392 3.25 8.99971V4.99971C3.25 4.58549 3.58579 4.24971 4 4.24971C4.41421 4.24971 4.75 4.58549 4.75 4.99971V7.00667C5.48348 5.96891 6.43646 5.09486 7.55003 4.45154Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89686 12.2572C4.30713 12.2002 4.68594 12.4866 4.74295 12.8969C4.96487 14.4937 5.70565 15.9733 6.85119 17.1077C7.99673 18.2421 9.48347 18.9684 11.0824 19.1747C12.6813 19.381 14.3037 19.0559 15.6997 18.2494C16.7566 17.6389 17.6393 16.7781 18.2748 15.7501H16.0001C15.5859 15.7501 15.2501 15.4143 15.2501 15.0001C15.2501 14.5859 15.5859 14.2501 16.0001 14.2501H19.4833C19.4947 14.2498 19.5061 14.2498 19.5175 14.2501H20.0001C20.4143 14.2501 20.7501 14.5859 20.7501 15.0001V19.0001C20.7501 19.4143 20.4143 19.7501 20.0001 19.7501C19.5859 19.7501 19.2501 19.4143 19.2501 19.0001V16.9931C18.5166 18.0309 17.5636 18.9049 16.4501 19.5483C14.7692 20.5193 12.8157 20.9108 10.8904 20.6624C8.9652 20.414 7.17504 19.5394 5.79572 18.1735C4.4164 16.8076 3.52443 15.0261 3.25723 13.1033C3.20022 12.6931 3.48658 12.3142 3.89686 12.2572Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6637_128116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.867d9722.svg";
export { ForwardRef as ReactComponent };